import {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmModal, TextArea} from 'components';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.DEESCALATE_DIALOG;

type Props = {
    open: boolean;
    loading?: boolean;
    onClose: (confirm: boolean, data?: {context: string}) => void
}
export const DeescalateDialog: React.FC<Props> = ({open, loading, onClose}) => {
    const {t} = useTranslation();
    const [context, setContext] = useState('');

    const handleClose = useCallback((confirm: boolean) => {
        onClose(confirm, confirm ? {context} : null);
    }, [context, onClose]);

    return (
        <ConfirmModal
            open={open}
            maxWidth='sm'
            fullWidth
            title={t(T_KEYS.TITLE)}
            okDisabled={loading}
            onClose={handleClose}
        >
            <div>{t(T_KEYS.DESCRIPTION)}</div>
            <TextArea
                className='tw-mt-4'
                rows={4}
                description={t(T_KEYS.PLACEHOLDER)}
                value={context}
                onChange={setContext}
            />
        </ConfirmModal>
    );
};